import {classBindThis} from "@irati/utils/functions"
import {isLoggingEnabled} from "../utils/env"

export type LightLogger = Prettify<
  Pick<Console, "log" | "warn" | "error" | "debug"> & {
    warnInvalid: (errors: string[], original: any) => void
    enableLogging(enabled: boolean): void
  }
>

type Level = "warn" | "debug"

export class BrazeLogger implements LightLogger {
  batch: any[][] = []

  timer: null | number = null

  constructor(
    private enabled = false,
    private timeout = 2,
    private collapsed = true,
    private level: Level = "warn"
  ) {
    classBindThis(this)
  }

  enableLogging(enabled: boolean): void {
    this.enabled = enabled
  }

  error(...message: any): void {
    this.batchLog(message)
  }

  log(...message: any): void {
    this.batchLog(message)
  }

  warn(...message: any): void {
    this.batchLog(["WARNING", ...message])
  }

  debug(...message: any): void {
    if (this.level === "debug") {
      this.batchLog(["DEBUG", ...message])
    }
  }

  warnInvalid(errors: string[], original: any) {
    this.warn("Invalid Braze Card:\n\n", "- " + errors.join("\n - "), "\n\nOriginal:", original)
  }

  private batchLog(message: any[]) {
    if (!this.enabled) {
      return
    }

    this.batch.push(message)

    if (this.timer === null) {
      this.timer = setTimeout(() => {
        this.print()
      }, this.timeout * 1000)
    }
  }

  private print() {
    if (this.collapsed) {
      console.groupCollapsed("Braze")
    } else {
      console.group("Braze")
    }
    this.batch.forEach((m) => console.log(...m))
    this.batch = []
    this.timer = null
    console.groupEnd()
  }
}

/** initialse the default logger for production */
export const createBrazeLogger = () => new BrazeLogger(isLoggingEnabled)
